import {
  faTimes,
  faPlus,
  faFile,
  faEllipsisVertical,
  faPenToSquare,
  faTrash,
} from "@fortawesome/free-solid-svg-icons";
import "./components.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useState } from "react";
import {
  Popover,
  PopoverAnchor,
  PopoverContent,
  SelectInput,
  TextareaInput,
  TextInput,
  ToggleInput,
} from "../../input";
import { generateKey } from "../../input/generateID";
import { GrigoraEditorContext } from "../context";
import slugify from "slugify";
import { makeID } from "../../helpers";
import { motion } from "framer-motion";
import { ModalInput } from "../../ui-kit";
import { INPUT_LIMITS } from "../../input-limits";
const ComponentsCard = (props) => {
  const { page, type } = props;
  const [toggle, setToggle] = useState(false);
  const [editPageModal, setEditPageModal] = useState(false);

  const {
    currentPage,
    changeCurrentPage,
    setLeftWidget,
    deletePage,
    projectComponents,
    setProjectComponents,
    pagesData,
    setPrevPage,
  } = useContext(GrigoraEditorContext);

  return (
    <>
      <div
        key={`component-switch-${page}`}
        onClick={() => {
          if (page !== currentPage) {
            changeCurrentPage(page);
            setPrevPage(currentPage);
          }
          setLeftWidget("");
        }}
        className={`grigora-page-tile border border-transparent hover:border-ui-dark-blue duration-200 page-${page} bg-white cursor-pointer relative px-4 py-3 pr-0 rounded-[8px] mb-2 flex gap-2 items-center ${
          page === currentPage ? "active" : ""
        }`}
      >
        <span
          className="text-ellipsis whitespace-nowrap"
          title={projectComponents[page]?.title}
        >
          {projectComponents[page]?.title}
        </span>
        <div className="ml-auto px-2">
          <Popover placement="right" open={toggle} onOpenChange={setToggle}>
            <PopoverAnchor
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setToggle(!toggle);
              }}
            >
              <span
                className={`ml-auto px-2 rounded-full border border-transparent hover:border-purple-500 duration-200 hover:bg-purple-200 ${
                  toggle ? "bg-purple-200 border-purple-500" : ""
                }`}
              >
                <FontAwesomeIcon icon={faEllipsisVertical} size="sm" />
              </span>
            </PopoverAnchor>
            <PopoverContent
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
              className="!z-[10000] !rounded-[6px] !bg-white !shadow-editor-floating-elements"
            >
              <div className="p-3 w-24">
                <button
                  onClick={() => setEditPageModal(!editPageModal)}
                  className="component-action-btn border-blue-500 text-blue-500 hover:bg-blue-500 hover:text-white text-grigora-base"
                >
                  <FontAwesomeIcon icon={faPenToSquare} size="xs" /> Edit
                </button>
                {
                  <>
                    <br />
                    <button
                      onClick={() => {
                        var tempComp = {
                          ...(projectComponents ? projectComponents : {}),
                        };
                        delete tempComp[page];
                        setProjectComponents(tempComp);
                        if (Object.keys(tempComp).length > 0) {
                          changeCurrentPage(Object.keys(tempComp)[0]);
                          return;
                        }
                        if (Object.keys(pagesData).length > 0) {
                          changeCurrentPage(Object.keys(pagesData)[0]);
                          setLeftWidget("pages");
                          return;
                        }
                      }}
                      className="component-action-btn border-red-500 text-red-500 hover:bg-red-500 hover:text-white  text-grigora-base"
                    >
                      <FontAwesomeIcon icon={faTrash} size="xs" /> Delete
                    </button>
                  </>
                }
              </div>
            </PopoverContent>
          </Popover>
          <EditComponent
            state={editPageModal}
            setState={setEditPageModal}
            page={page}
          />
        </div>
      </div>
    </>
  );
};

const EditComponent = (props) => {
  const { state, setState, page } = props;
  const {
    project,
    pagesData,
    projectComponents,
    setProjectComponents,
    updatePageData,
  } = useContext(GrigoraEditorContext);
  const [formPage, setFormPage] = useState(projectComponents[page]);

  return (
    <ModalInput
      isOpened={state}
      onOutsideClick={() => {
        setState(false);
      }}
    >
      <div className="rounded-[21px] bg-white grigora-add-new-page gap-2 grigora-custom-scrollbar-dark flex flex-col mw-[50pw] mh-[80vh] w-[50vw] h-[60vh] p-5 cursor-default">
        <div className="modal-heading">Edit Component</div>
        <div className="overflow-y-auto grigora-custom-scrollbar-dark pr-2">
          <div className="grigora-add-new-page__form-name text-sm mb-2">
            <div className="mb-2">Component Name</div>
            <TextInput
              minLength={INPUT_LIMITS["component-name"].minlength}
              maxLength={INPUT_LIMITS["component-name"].maxlength}
              isResetVisible={false}
              value={formPage.title}
              onChange={(val) => {
                setFormPage({ ...formPage, title: val });
              }}
            />
          </div>
        </div>
        <div className="mt-auto">
          <div className="grigora-add-new-page__btns text-sm flex gap-[10px] justify-end ">
            <div
              onClick={() => {
                setProjectComponents({
                  ...(projectComponents ? projectComponents : {}),
                  [page]: {
                    ...projectComponents[page],
                    title: formPage.title,
                  },
                });
                setState(false);
              }}
              className="grigora-action-btn"
            >
              Update
            </div>
          </div>
        </div>
      </div>
    </ModalInput>
  );
};

const Components = () => {
  const { pagesData, setLeftWidget, project, addNewPage, projectComponents } =
    useContext(GrigoraEditorContext);

  return (
    <>
      <motion.div
        initial={{ x: -400 }}
        animate={{ x: 0 }}
        exit={{ x: -400 }}
        transition={{ duration: 0.3, delay: 0 }}
        key="pages"
        style={{
          clipPath: "inset(0px -200vw -100vh 0px)",
        }}
        className="bg-white border-l border-t shadow-editor-floating-elements z-[-1] w-[400px] text scroll-auto select-none"
      >
        <div className="h-10 w-[400px] border-b flex px-5 items-center">
          <h4 className="text-[14px] w-full font-medium flex items-center justify-between">
            Components
            <span
              onClick={() => {
                setLeftWidget("");
              }}
              className="float-right cursor-pointer duration-200 w-[25px] h-[25px] flex items-center justify-center rounded-full hover:bg-gray-100"
            >
              <FontAwesomeIcon icon={faTimes} />
            </span>
          </h4>
        </div>
        <div className="grigora-left-sidebar__pages text-grigora-base">
          <div className="p-2 overflow-y-auto h-[90vh]">
            {Object.keys(projectComponents).map((component) => {
              return (
                <ComponentsCard
                  key={component}
                  page={component}
                  type={"component"}
                />
              );
            })}
          </div>
        </div>
      </motion.div>
    </>
  );
};

export default Components;
